import { Box } from '@mui/material';
import { PaginationIndicator } from 'ogp/components/common/pagination-indicator';
import { useLevelPagination } from 'ogp/hooks/queryHooks/misc/use-level-pagination';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { LWModal } from 'redesign/modal/modal';
import { ExternalFlexPoolsTable } from './table';
import { useWorkersPoolDetail } from './hooks/use-workers-pool-detail';
import { useGetExternalFlexPools } from '../../hooks/use-get-external-flex-pools';
import { WorkersPoolDetail } from '../../../flex-pool-external-detail/workers-pool-detail';

export const ExternalFlexPools = () => {
  const pagination = useLevelPagination();
  const { id, open, close } = useWorkersPoolDetail();
  const flexPoolListQuery = useGetExternalFlexPools({
    page: pagination.page,
    pageSize: pagination.size,
  });

  if (flexPoolListQuery.status !== 'success') {
    return <RenderUnsettledUI data={flexPoolListQuery} />;
  }

  const { items, totalRows } = flexPoolListQuery.data;

  return (
    <Box display="flex" width="100%" maxHeight={'100%'} flexDirection={'column'}>
      <ExternalFlexPoolsTable data={items} onRowClick={(row) => open(row.id)} />
      <Box mt="auto">
        <PaginationIndicator pageCount={totalRows} pagination={pagination} />
      </Box>
      <LWModal isOpen={!!id} onClose={close}>
        {id ? <WorkersPoolDetail id={id} onClose={close} /> : null}
      </LWModal>
    </Box>
  );
};
